/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMattermostIcon16Solid = forwardRef('LogoMattermostIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m12.187 3.822-.074-1.486a6.998 6.998 0 1 1-3.926-1.334L7.23 2.135c-1.772.32-3.303 1.531-3.904 3.308-.895 2.644.605 5.541 3.35 6.47 2.746.93 5.697-.46 6.593-3.104.6-1.77.124-3.655-1.08-4.986Z" }),
        React.createElement("path", { d: "M10.267 1.796c.041 1.641.085 3.283.13 4.924.033 1.42-1.288 2.474-2.646 2.015-1.358-.46-1.766-2.1-.878-3.208C7.906 4.25 8.949 2.982 9.968 1.694c.107-.104.28-.055.299.102Z" })));
});
